import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { get } from "../../lib/request";
import { buildAlertAssigneesFetchKey, resolveSingleAlertClientId } from "./fetchCacheUtils";

export const fetchAlertGroups = createAsyncThunk(
  "alertGroups/fetch",
  async (arg, { rejectWithValue }) => {
    try {
      const clientId = resolveSingleAlertClientId(arg);
      if (clientId == null) {
        return rejectWithValue("clientId is required");
      }

      const res = await get(`alert-groups?clientIds=${encodeURIComponent(clientId)}`);

      if (Array.isArray(res)) return res;
      if (Array.isArray(res?.data)) return res.data;
      if (Array.isArray(res?.data?.data)) return res.data.data;

      return [];
    } catch (err) {
      console.error("❌ alert-group API error:", err);
      return rejectWithValue(err.response?.data || err.message);
    }
  },
  {
    condition: (arg, { getState }) => {
      if (arg?.force === true) return true
      const key = buildAlertAssigneesFetchKey(arg)
      if (!key) return false
      const s = getState().alertGroups
      if (s.loading && s.lastFetchKey === key) return false
      if (s.status === "succeeded" && s.lastFetchKey === key) return false
      return true
    },
  },
);

const alertGroupsSlice = createSlice({
  name: "alertGroups",
  initialState: {
    groups: [],
    loading: false,
    error: null,
    status: "idle",
    lastFetchKey: null,
  },
  reducers: {
    clearAlertGroups: (state) => {
      state.groups = []
      state.loading = false
      state.error = null
      state.status = "idle"
      state.lastFetchKey = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlertGroups.pending, (state, action) => {
        state.loading = true;
        state.status = "loading"
        state.lastFetchKey = buildAlertAssigneesFetchKey(action.meta.arg)
      })
      .addCase(fetchAlertGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded"
        state.groups = action.payload || [];
      })
      .addCase(fetchAlertGroups.rejected, (state, action) => {
        console.error("❌ fetchAlertGroups rejected:", action.payload);
        state.loading = false;
        state.status = "failed"
        state.error = action.payload;
      });
  },
});

export const { clearAlertGroups } = alertGroupsSlice.actions
export default alertGroupsSlice.reducer;
